// v4.0老功能 服务商首次维护
<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>服务商首次维护</span>
    </div>
    <!-- end of title -->

    <el-form :model="formData" :rules="formRules" ref="formData" label-width="150px">
      <!-- start of 合同信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">合同信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" prop="tenantName">
                <el-select
                  clearable
                  size="small"
                  :disabled="guid ? true : false"
                  filterable
                  v-model="formData.tenantName"
                  placeholder="请选择"
                  @change="changeTenant"
                >
                  <el-option
                    v-for="(item, index) in tenantList"
                    :key="item.guid"
                    :label="item.tenantName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司简称 -->
              <el-form-item label="公司简称" prop="abbreviation">
                <el-input
                  :maxlength="50"
                  placeholder="请输入"
                  size="small"
                  min="0"
                  v-model="formData.abbreviation"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司成立时间 -->
              <el-form-item label="公司成立时间" prop="servicerCredential.establishDate">
                <el-date-picker
                  size="small"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  v-model="formData.servicerCredential.establishDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 注册资本(万元) -->
              <el-form-item label="注册资本(万元)" prop="servicerCredential.registeredCapital">
                <el-input
                  type="text"
                  :maxlength="12"
                  placeholder="请输入"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  size="small"
                  min="0"
                  v-model="formData.servicerCredential.registeredCapital"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 是否实缴 -->
              <el-form-item label="是否实缴" prop="servicerCredential.isPaidIn">
                <el-radio-group v-model="formData.servicerCredential.isPaidIn">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司组织形式 -->
              <el-form-item label="公司组织形式" prop="servicerCredential.enterpriseCate">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.servicerCredential.organizationForm"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in getCodeListByKey('公司组织形式')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 证照年审是否正常 -->
              <el-form-item label="证照年审是否正常" prop="servicerCredential.annualReviewState">
                <el-radio-group v-model="formData.servicerCredential.annualReviewState">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 合同有效期至 -->
              <el-form-item label="合同有效期至" prop="servicerCredential.cooperationValidityDate">
                <el-date-picker
                  size="small"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  v-model="formData.servicerCredential.cooperationValidityDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 业务联系人 -->
              <el-form-item label="业务联系人" prop="contacts">
                <el-input
                  :maxlength="10"
                  placeholder="请填写"
                  size="small"
                  type="text"
                  v-model="formData.contacts"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 联系电话 -->
              <el-form-item label="业务联系人电话" prop="contactTel">
                <el-input
                  type="text"
                  onkeyup="value=value.replace(/[^0-9]/g,'')"
                  :maxlength="11"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.contactTel"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 合作税率 -->
            <!-- <el-col :span="12">
              <el-form-item label="合作税率(%)" prop="servicerCredential.cooperationTaxRate">
                <el-input type="text" :maxlength="12" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" placeholder="请输入" size="small" v-model="formData.servicerCredential.cooperationTaxRate">
                </el-input>
              </el-form-item>
            </el-col> -->

            <!-- 费用类型 -->
            <el-col :span="12">
              <el-form-item label="费用类型" prop="expenseType">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.expenseType"
                  placeholder="请选择"
                  @change="expenseTypeChange"
                >
                  <el-option
                    v-for="(item, index) in expenseTypeList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 显示不同的费用类型 ----1: SAAS服务费率 值是百分比 -->
            <el-col
              :span="12"
              v-if="formData.expenseType == '1' && formData.servicerCredential.cooperationTaxRate >= 0"
            >
              <el-form-item label="SAAS服务费率(%)" prop="servicerCredential.cooperationTaxRate">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.servicerCredential.cooperationTaxRate"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 显示不同的费用类型 ----2：SAAS服务费 值是金额  单位万元 -->
            <el-col :span="12" v-if="formData.expenseType == '2' && formData.servicerCredential.costMoney >= 0">
              <el-form-item label="SAAS服务费(万元)" prop="servicerCredential.costMoney">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.servicerCredential.costMoney"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 介绍人 -->
              <el-form-item label="介绍人" prop="servicerCredential.introducer">
                <el-input
                  type="text"
                  :maxlength="10"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.servicerCredential.introducer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 月度合作上限(元) -->
              <el-form-item label="月度合作上限(元)" prop="servicerCredential.monthMaxMoney">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.servicerCredential.monthMaxMoney"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 联系电话 -->
              <el-form-item label="介绍人电话" prop="servicerCredential.introducerTel">
                <el-input
                  type="text"
                  onkeyup="value=value.replace(/[^0-9]/g,'')"
                  :maxlength="11"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.servicerCredential.introducerTel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 开票类型 -->
              <el-form-item label="开票类型" prop="servicerCredential.invoiceType">
                <el-select
                  size="small"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  v-model="formData.servicerCredential.invoiceType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in billingTypeList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 是否合作 -->
              <el-form-item label="是否合作" prop="servicerCredential.isCooperation">
                <el-radio-group v-model="formData.servicerCredential.isCooperation">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 税号 -->
              <el-form-item label="税号" prop="taxpayerId">
                <el-input size="small" v-model="formData.taxpayerId"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 公司地址 -->
              <el-form-item label="公司地址">
                <span slot="label" style="color: red; margin-right: 4px">*</span>
                <span slot="label">公司地址 </span>
                <el-cascader
                  size="small"
                  ref="cascaderFirst"
                  style="width: 314px"
                  @change="incres"
                  filterable
                  :options="options"
                  v-model="addressList"
                >
                </el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司电话 -->
              <el-form-item label="公司电话" prop="tel">
                <el-input
                  size="small"
                  v-model="formData.tel"
                  @blur="checkPhone(formData.tel)"
                  :maxlength="13"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 详细地址 -->
              <el-form-item label="" prop="address">
                <el-input type="textarea" style="width: 314px" v-model="formData.address"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 营业执照 -->
          <el-form-item label="营业执照">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeBusinessList"
                :http-request="uploadBusinesslicense"
                :file-list="businesslicenseList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="businesslicenseList && businesslicenseList.length > 0">
                <a
                  :href="businesslicenseList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(businesslicenseList[0].path, businesslicenseList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 合同信息 -->

      <!-- start of 证件信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">证件信息</span>
        <div class="form-item-box">
          <!-- 完税证明 -->
          <el-form-item label="完税证明" prop="servicerCredential.taxPaymentCertificateDate">
            <el-select
              size="small"
              clearable
              v-model="formData.servicerCredential.taxPaymentCertificateDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>

            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeTaxPaymentList"
                :http-request="uploadTaxPayment"
                :file-list="taxPaymentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="taxPaymentList && taxPaymentList.length > 0">
                <a
                  :href="taxPaymentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(taxPaymentList[0].path, taxPaymentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 个税扣缴明细 -->
          <el-form-item label="个税扣缴明细" prop="servicerCredential.privateTaxDetailDate">
            <el-select
              size="small"
              clearable
              v-model="formData.servicerCredential.privateTaxDetailDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removePrivateTaxList"
                :http-request="uploadPrivateTax"
                :file-list="privateTaxList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="privateTaxList && privateTaxList.length > 0">
                <a
                  :href="privateTaxList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(privateTaxList[0].path, privateTaxList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 证件信息 -->

      <!-- start of 银行信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">银行信息</span>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <div class="sub-title">
            银行信息{{ index + 1 }}
            <span class="sub-operate-add" @click="addBankItem">新增</span>
            <span class="sub-operate-add" @click="delBankItem(index)" v-show="index != 0">删除</span>
          </div>
          <el-row>
            <el-col :span="12">
              <!-- 账户类型-->
              <el-form-item label="账户类型" required>
                <el-select size="small" clearable v-model="item.accountType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in [
                      { label: '基本户', value: '1' },
                      { label: '一般户', value: '2' },
                      { label: '开票户', value: '3' },
                      { label: '打款户', value: '4' },
                    ]"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 银行名称 -->
              <el-form-item label="银行名称" required>
                <el-input type="text" v-model="item.bankName" :maxlength="100" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 银行卡号 -->
              <el-form-item label="银行卡号" required>
                <el-input
                  type="text"
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  v-model="item.bankAccount"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="bottom-btn-box">
          <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
        </div>
      </div>
      <!-- end of 银行信息 -->
    </el-form>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      guid: '',
      options: areaJson,
      addressList: [],
      address: [],
      detailAddres: '',
      propsOp: {
        value: 'label',
        label: 'label',
        children: 'children',
      },
      // 表单字段
      formData: {
        province: null,
        city: null,
        district: null,
        venue: null,
        address: '',
        publicOfficials: '', // 企业名称
        abbreviation: '', // 简称
        servicerCredential: {
          establishDate: '', // 公司成立时间
          registeredCapital: '', // 注册资本
          organizationForm: '', // 公司组织形式
          isPaidIn: '', // 是否实缴
          annualReviewState: '', // 证照年审状态
          cooperationTaxRate: '', // 合作税率
          cooperationValidityDate: '', // 合同有效期至
          monthMaxMoney: '', // 月度合作上限
          invoiceType: '', // 开票类型
          introducer: '', // 介绍人
          introducerTel: '', // 联系电话
          taxPaymentCertificateDate: '', // 完税证明
          privateTaxDetailDate: '', // 个税扣缴明细
          isCooperation: 'Y', // 是否合作
        },
        contacts: '', // 业务联系人
        contactTel: '', // 业务联系人电话
        expenseType: null,
        bankList: [
          {
            //银行信息
            accountType: '',
            bankName: '',
            bankAccount: '',
          },
        ],
      },
      // 表单验证规则
      formRules: {
        tenantName: [{ required: true, message: '公司名称必填', trigger: 'change' }],
        contacts: [{ required: true, message: '业务联系人必填', trigger: 'change' }],
        contactTel: [{ required: true, message: '业务联系人电话必填', trigger: 'change' }],
        tel: [{ required: true, message: '请输入正确的电话', trigger: 'change' }],
        address: [{ required: true, message: '公司地址必填', trigger: 'change' }],
        taxpayerId: [{ required: true, message: '税号必填', trigger: 'change' }],
        // 'servicerCredential.cooperationTaxRate': [
        //   { required: true, message: '合作税率必填', trigger: 'blur' }
        // ],
        'servicerCredential.monthMaxMoney': [{ required: true, message: '月度合作上限必填', trigger: 'blur' }],
        'servicerCredential.introducer': [{ required: true, message: '介绍人必填', trigger: 'blur' }],
        'servicerCredential.introducerTel': [{ required: true, message: '介绍人电话必填', trigger: 'blur' }],
        // bankName:[
        //   { required: true, message: '银行名称必填', trigger: 'change' }
        // ],
        // bankAccount:[
        //   { required: true, message: '银行账号必填', trigger: 'change' }
        // ],
        // accountType:[
        //   { required: true, message: '账户类型必填', trigger: 'change' }
        // ]
      },
      // 企业下拉选数据
      tenantList: [],
      // 开票类型下拉选数据 --信息技术服务费发票，市场推广服务费发票
      billingTypeList: [
        {
          text: '信息技术服务费发票',
          value: '1',
        },
        {
          text: '市场推广服务费发票',
          value: '2',
        },
      ],
      // 完税证明、个税扣缴明细下拉选数据
      monthsList: [
        {
          text: '近3个月',
          value: 3,
        },
        {
          text: '近6个月',
          value: 6,
        },
        {
          text: '近12个月',
          value: 12,
        },
      ],
      // 费用类型下拉选数据
      expenseTypeList: [
        {
          text: 'SAAS服务费率',
          value: '1',
        },
        {
          text: 'SAAS服务费',
          value: '2',
        },
      ],
      expenseTypeObj: {
        1: {
          label: 'SAAS服务费率(%)',
          prop: 'cooperationTaxRate',
        },
        2: {
          label: 'SAAS服务费(万元)',
          prop: 'costMoney',
        },
      },
      // acceptFile: '.xlsx,.xsl,.xls,.xlsm,.doc,.docx,.png,.jpg,.jpeg,.pdf',
      acceptFile: '*',
      tips: '注意：支持所有文件，单个文件大小需 <= 20M',

      // 营业执照文件
      businesslicenseList: [],
      // 完税证明文件
      taxPaymentList: [],
      // 个人扣缴明细文件
      privateTaxList: [],
    };
  },
  created() {
    this.getTenantData(); // 获取企业接口
    // 修改时需要获取详情数据，给表单赋值
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetailData(this.guid);
    }
  },
  methods: {
    /**
     * 获取企业数据
     */
    getTenantData() {
      let that = this;
      that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          enterpriseCate: '9901',
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.tenantList = res.data.data.records || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 更改企业时，需要将其他数据带出来
     * @param {*} guid
     */
    changeTenant(guid) {
      this.getDetailData(guid);
    },
    /**
     * 修改费用类型
     */
    expenseTypeChange(val) {
      // console.log(val)
      if (val == '1') {
        this.formData['levyEnterprise']['costMoney'] = null;
      }
      if (val == '2') {
        this.formData['levyEnterprise']['cooperationTaxRate'] = null;
      }
    },
    /**
     * 获取表单数据
     */
    getDetailData(guid) {
      let that = this;
      let formData = {};
      that.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=` + guid).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || that.formData;
          formData['guid'] = datas['guid'];
          formData['enterpriseCate'] = datas['enterpriseCate'];
          formData['tenantName'] = datas['tenantName'];
          formData['abbreviation'] = datas['abbreviation'];
          formData['contacts'] = datas['contacts'];
          formData['contactTel'] = datas['contactTel'];
          formData['address'] = datas['address'];
          formData['taxpayerId'] = datas['taxpayerId'];
          formData['tel'] = datas['tel'];
          formData['province'] = datas['province'];
          formData['city'] = datas['city'];
          formData['district'] = datas['district'];

          // 填充地址
          if (!datas.province) {
            this.addressList = [];
          } else {
            this.addressList = [datas.province, datas.city, datas.district];
          }

          // 服务商平台数据
          if (!datas['servicerCredential']) {
            formData['servicerCredential'] = {
              guid: datas['guid'], // 公司成立时间
              establishDate: null, // 公司成立时间
              registeredCapital: null, // 注册资本
              organizationForm: null, // 公司组织形式
              isPaidIn: null, // 是否实缴
              annualReviewState: null, // 证照年审状态
              cooperationTaxRate: null, // 合作税率
              costMoney: null, // 固定金额
              cooperationValidityDate: null, // 合同有效期至
              monthMaxMoney: null, // 月度合作上限
              invoiceType: null, // 开票类型
              introducer: null, // 介绍人
              introducerTel: null, // 联系电话
              taxPaymentCertificateDate: null, // 完税证明
              privateTaxDetailDate: null, // 个税扣缴明细
              isCooperation: 'Y', // 是否合作
            };
          } else {
            formData['servicerCredential'] = datas['servicerCredential'];

            // 开票类型存在数据库是字符串，取值得时候需要转换成数组
            if (datas['servicerCredential']['invoiceType']) {
              formData['servicerCredential']['invoiceType'] = datas['servicerCredential']['invoiceType'].split(',');
            }

            // 营业执照文件
            if (datas['servicerCredential']['businessLicenseUrl']) {
              let file = datas['servicerCredential']['businessLicenseUrl'].split('/');
              that.businesslicenseList = [
                {
                  name: file[file.length - 1],
                  path: datas['servicerCredential']['businessLicenseUrl'],
                },
              ];
            }

            // 完税证明文件
            if (datas['servicerCredential']['taxPaymentCertificateUrl']) {
              let file = datas['servicerCredential']['taxPaymentCertificateUrl'].split('/');
              that.taxPaymentList = [
                {
                  name: file[file.length - 1],
                  path: datas['servicerCredential']['taxPaymentCertificateUrl'],
                },
              ];
            }

            // 个人扣缴明细文件
            if (datas['servicerCredential']['privateTaxDetailUrl']) {
              let file = datas['servicerCredential']['privateTaxDetailUrl'].split('/');
              that.privateTaxList = [
                {
                  name: file[file.length - 1],
                  path: datas['servicerCredential']['privateTaxDetailUrl'],
                },
              ];
            }

            // 费用类型
            if (
              datas['servicerCredential']['costMoney'] == -1 ||
              (datas['servicerCredential']['cooperationTaxRate'] &&
                datas['servicerCredential']['cooperationTaxRate'] >= 0)
            ) {
              formData['expenseType'] = '1';
              formData['servicerCredential']['costMoney'] = null;
            }
            if (
              datas['servicerCredential']['cooperationTaxRate'] == -1 ||
              (datas['servicerCredential']['costMoney'] && datas['servicerCredential']['costMoney'] >= 0)
            ) {
              formData['expenseType'] = '2';
              formData['servicerCredential']['cooperationTaxRate'] = null;
            }
            if (!datas['servicerCredential']['cooperationTaxRate'] && !datas['servicerCredential']['costMoney']) {
              formData['expenseType'] = '';
              formData['servicerCredential']['costMoney'] = null;
              formData['servicerCredential']['cooperationTaxRate'] = null;
            }
            //银行信息
            if (datas.bankList && datas.bankList.length) {
              formData['bankList'] = datas.bankList;
            } else {
              formData['bankList'] = [
                {
                  //银行信息
                  accountType: null,
                  bankName: null,
                  bankAccount: null,
                },
              ];
            }
          }
          that.$set(that, 'formData', formData);
          // console.log('-----------')
          console.log(that.formData);
        }
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      let that = this;
      let { formData } = this;
      let postData = JSON.parse(JSON.stringify(formData));

      // 费用类型
      // if(postData['servicerCredential'] && formData.expenseType == '1' && !postData['servicerCredential']['cooperationTaxRate']) {
      //   return this.$message.warning('请填写SAAS服务费率')
      // }
      // if(postData['servicerCredential'] && formData.expenseType == '2' && !postData['servicerCredential']['costMoney']) {
      //   return this.$message.warning('请填写SAAS服务费')
      // }
      if (postData['servicerCredential'] && formData.expenseType == '1') {
        postData['servicerCredential']['costMoney'] = -1;
      }
      if (postData['servicerCredential'] && formData.expenseType == '2') {
        postData['servicerCredential']['cooperationTaxRate'] = -1;
      }

      if (
        !formData.expenseType ||
        (!postData['servicerCredential']['cooperationTaxRate'] && !postData['servicerCredential']['costMoney'])
      ) {
        postData['servicerCredential']['costMoney'] = -1;
        postData['servicerCredential']['cooperationTaxRate'] = -1;
      }

      // 开票类型存在数据库是字符串
      if (postData['servicerCredential'] && postData['servicerCredential']['invoiceType']) {
        postData['servicerCredential']['invoiceType'] = postData['servicerCredential']['invoiceType'].toString();
      }
      if (this.formData.bankList.length > 0) {
        try {
          this.formData.bankList.forEach((item) => {
            if (!item.accountType) {
              throw new Error('账户类型不能为空');
            }
            if (!item.bankName) {
              throw new Error('银行名称不能为空');
            }
            if (!item.bankAccount) {
              throw new Error('银行卡号不能为空');
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          that.api.put(`/${serverConfig.msCustomerService}/tenant/data/update`, postData).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('保存成功');
              that.$router.go(-1); // 返回上一页
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 上传营业执照文件-导入
     */
    uploadBusinesslicense(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        console.log(status);
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.businesslicenseList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 营业执照路径赋值
          self.formData.servicerCredential['businessLicenseUrl'] = res.data.data.data;
          return;
        }
        if (status == 2) {
          self.removeBusinessList();
        }
      });
    },
    /**
     * 上传完税证明文件-导入
     */
    uploadTaxPayment(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.taxPaymentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 完税证明路径赋值
          self.formData.servicerCredential['taxPaymentCertificateUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeTaxPaymentList();
        }
      });
    },
    /**
     * 上传个人扣缴明细文件-导入
     */
    uploadPrivateTax(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.privateTaxList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 个人扣缴明细路径赋值
          self.formData.servicerCredential['privateTaxDetailUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removePrivateTaxList();
        }
      });
    },
    /**
     * 附件上传方法
     * @param {*} file
     * @param {*} fn
     */
    uploadData(file, fn) {
      let self = this;
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      self.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // 成功回调
            if (fn) fn(1, res);
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            // 失败回调
            if (fn) fn(2, res);
            self.$message.error('上传失败!');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 移除营业执照文件
     */
    removeBusinessList() {
      this.businesslicenseList = [];
      this.formData.servicerCredential['businessLicenseUrl'] = '';
    },
    /**
     * 移除完税证明文件
     */
    removeTaxPaymentList() {
      this.taxPaymentList = [];
      this.formData.servicerCredential['taxPaymentCertificateUrl'] = '';
    },
    /**
     * 移除个人扣缴明细文件
     */
    removePrivateTaxList() {
      this.privateTaxList = [];
      this.formData.servicerCredential['privateTaxDetailUrl'] = '';
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /**
     * 上传前校验
     */
    beforeAvatarUpload(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      const isJPG =
        fileSuffix === 'xlsx' ||
        fileSuffix === 'xsl' ||
        fileSuffix === 'xls' ||
        fileSuffix === 'xlsm' ||
        fileSuffix === 'doc' ||
        fileSuffix === 'docx' ||
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf';
      const isLt5M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      //   this.$message.error('文件格式不正确!');
      // }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过20MB!');
      }
      return isJPG && isLt5M;
    },
    /**
     * 查看文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    seeDetail(url, name) {
      var fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(url, name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
    },
    //新增银行
    addBankItem() {
      this.formData['bankList'].push({
        accountType: null,
        bankName: null,
        bankAccount: null,
      });
    },
    //删除银行
    delBankItem(index) {
      this.formData['bankList'].splice(index, 1);
    },
    addressChange(val) {
      if (val && val.length) {
        this.formData.address = `${val.join('')}${this.formData.address || ''}`;
      }
    },
    checkPhone(value) {
      let { formData } = this;
      if (/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(value)) {
        formData.tel = value;
      } else {
        formData.tel = '';
      }
    },
    incres(area) {
      this.formData.province = area[0];
      this.formData.city = area[1];
      this.formData.district = area[2];
      let venue = '';
      if (area) {
        if (area[0]) {
          venue = this.province(area[0]);
        }
        if (area[1]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]);
        }
        if (area[2]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]) + '/' + this.district(area[2]);
        }
      }
      this.formData.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 8px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      width: 132px;
      margin-left: 16px;
      height: 32px;
    }
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  padding: 10px 0;
  margin-left: -44px;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
</style>
